import { IMAGES, CONTACT } from "@/lib/site";

export const Hero = () => (
  <section className="relative min-h-[580px] lg:min-h-[640px] flex items-center bg-stone-900 text-white overflow-hidden border-b border-stone-300" data-testid="hero-section">
    <img
      src={IMAGES.hero}
      alt="Land surveying tripod and total station silhouetted over a Central Ohio development site at sunset"
      className="absolute inset-0 w-full h-full object-cover"
      data-testid="hero-image"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-stone-950 via-stone-900/85 to-stone-950/70 z-10"></div>
    <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 animate-geodetic-fade">
      <div className="max-w-3xl">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-[1.1] mb-6" data-testid="hero-headline">
          Thirty-Five Years of Definitive Field Precision
        </h1>
        <p className="text-lg sm:text-xl text-stone-200 leading-relaxed mb-8 font-light" data-testid="hero-differentiator">
          Senior-level attention on every boundary, ALTA survey, and stormwater design. One owner-engineer handles every phase directly: licensed PE, PS, and RLS in one person, serving Dublin, Columbus, and Central Ohio.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
          <a href="#contact" data-testid="hero-cta" className="inline-flex items-center justify-center px-6 py-3.5 rounded bg-amber-700 hover:bg-amber-600 text-white text-base font-semibold transition-colors shadow-lg shadow-amber-900/40">
            Submit Your Central Ohio Project
          </a>
          <span className="text-xs text-stone-300 sm:pl-3" data-testid="hero-email">Direct contact with Steve Lamphear: {CONTACT.email}</span>
        </div>
      </div>
    </div>
  </section>
);
